import IntroZip from "./IntroZip.js";
import InlineErrorText from "./utils/InlineErrorText.js";
import FormInputs from "../services/inputs-service.js";
import Funnel from "../services/funnel-service.js";

const template = `
    <div v-if="fs.display(input)" @keydown.esc="toggleAltZip()">
        <transition name="slide-fade"" mode="out-in" @enter="offset(arguments)"  appear>
            <span class=" text-right zip-text h4" v-if="hideAddress" >
                <span v-if="this.$store.state.funnel.elements.in_address_city.value && this.$store.state.funnel.elements.in_address_city.options.length === 0"
                    v-text="this.$store.state.funnel.elements.in_address_city.value + ', '"
                ></span>
                <span v-if="this.$store.state.funnel.elements.in_address_state.value" v-text="this.$store.state.funnel.elements.in_address_state.value"></span>
                <span v-if="this.$store.state.funnel.elements.in_address_zip.value" v-text="this.$store.state.funnel.elements.in_address_zip.value"></span>
            </span>
        </transition>
        <transition name="slide-fade"" mode="out-in" @enter="offset(arguments)" appear>
            <qt-intro-zip :iuid="iuid" v-if="!hidden && input.mode !='modal'"/>
        </transition>
        <transition name="modal" mode="out-in"  @enter="computeMarginTop()" @after-enter="focusModal()">
            <div class="modal-mask" v-if="!hidden && input.mode == 'modal'" @keydown="handleKeyDown" tabindex="0">
                <div class="modal-wrapper">
                    <div class="s11 m10 l6 clm card center modal-card" :style="styleObject" :id="'modal_'+iuid"> 
                        <div class="modal-header grid">
                            <slot name="header">
                                <div role="dialog" aria-modal="true" aria-labelledby="correct-zip-dialog-title" class="s12 clm">
                                    <h3 tabindex="0" id="correct-zip-dialog-title" class="text-center">
                                        What's the correct ZIP Code?
                                    </h3>
                                </div>
                            </slot>
                        </div>
                        <qt-intro-zip :iuid="iuid"/>
                        <b-inline-error-text :iuid="input.error_uid" v-if="input.show_error"/>
                        <div class="modal-footer grid">
                            <slot name="footer">
                                <div class="s12 clm">
                                    <a role="button" tabindex='0' class="text-center" @click.prevent="toggleAltZip()" @keydown.enter="toggleAltZip()" @keydown.prevent.space="toggleAltZip()">{{input.nevermind_text}}</a>
                                </div>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <a role="button" tabindex='0' class="text-right wrong_zip" @click.prevent="toggleAltZip()" @keydown.enter="toggleAltZip()" @keydown.space.prevent="toggleAltZip()">{{input.hidden_text}}</a>
    </div>
    </transition>
`;
export default {
    name: 'b-intro-zip',
    template,
    props: ['iuid'],
    data: function(){
        return{
            styleObject:{}
        }
    },
    components: {
        'qt-intro-zip':IntroZip,
        'b-inline-error-text': InlineErrorText
    },
    mounted: function(){
        console.log("MOUNTED INPUT ALT ADDRESS, DISPLAY CLASSES: ",this.fs.class_display(this.input));
        if (!this.input.hide_zip) {
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'hide_zip', val: true});
        }
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        wrongZipText: function(){
            if (this.hidden) {
                return this.input.hidden_text
            }else{
                return this.input.nevermind_text
            }
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedMask:function(){
            return this.input.validation.mask
        },
        hidden: function(){
            return this.input.hide_zip
        },
        hideAddress: function(){
            if (!this.hidden && this.input.mode == 'modal') {
                return true
            }else{
                return this.hidden
            }
            
        },
        
    },
    methods: {
        focusModal: function(){
            console.log(this.fs.display(this.input));
            console.log("FOCUS MODAL!!!!!!!!!!!!!");
            console.log($('#modal_'+this.input.uid+' input'));
            $('#modal_'+this.input.uid+' input').focus(); 
        },
        computeMarginTop: function(){
            this.styleObject = {}
            var modal = document.getElementById('modal_'+this.iuid);
            var body = document.body;
            // var w = modal.offsetWidth;
            var h = modal.offsetHeight;
            var wh = window.innerHeight;
            // var bw = body.clientWidth;
            if (h >= wh) {
              return
            }
            this.styleObject.marginTop = (wh/2 - h/2) + "px"
            this.$forceUpdate()
        },
        offset: function(args){
            var self = this
           this.$nextTick(function(){
                $('#'+self.input.uid).removeClass('m-offset-6');
                if ($('#in_address_city').length == 0) {
                    this.$nextTick(function(){
                        $('#'+self.input.uid).addClass('m-offset-6');
                    })
                }
           })
        },
        toggleAltZip: function(){
            console.log('clicked toggleAltZip');
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'hide_zip', val: !this.input.hide_zip});
            return false;
        },
        exec: function (e) {
            //First commit mutation then process business logic.
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            fi.isValid(this.input);
            this.updateValue(e);
            fi.eventHandler(e, this.input);
        },
        hideModal: function(){
            this.hidden = false
        },
        maskClick: function(e){
            console.log(e.className);
            if (e.className.indexOf('modal-mask') > -1 || e.className.indexOf('modal-wrapper') > -1) {
                this.toggleAltZip()
            }
        },
        handleKeyDown(event) {
            const focusableElements = this.$el.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
        
            // Handle Tab key
            if (event.key === 'Tab') {
                if (event.shiftKey) { // Shift + Tab
                // If on the first element, move focus to the last element
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
                } else { // Tab
                // If on the last element, move focus to the first element
                if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
                }
            }
        },
    }
};
